module.exports = __webpack_public_path__ + "img/right_society.06a42665.png";